/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClientPersonalDetailsViewModel } from './ClientPersonalDetailsViewModel';
import {
    ClientPersonalDetailsViewModelFromJSON,
    ClientPersonalDetailsViewModelFromJSONTyped,
    ClientPersonalDetailsViewModelToJSON,
} from './ClientPersonalDetailsViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfClientPersonalDetailsViewModel
 */
export interface ResultOfClientPersonalDetailsViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfClientPersonalDetailsViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfClientPersonalDetailsViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfClientPersonalDetailsViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfClientPersonalDetailsViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfClientPersonalDetailsViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfClientPersonalDetailsViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfClientPersonalDetailsViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {ClientPersonalDetailsViewModel}
     * @memberof ResultOfClientPersonalDetailsViewModel
     */
    data?: ClientPersonalDetailsViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfClientPersonalDetailsViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfClientPersonalDetailsViewModel interface.
 */
export function instanceOfResultOfClientPersonalDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfClientPersonalDetailsViewModelFromJSON(json: any): ResultOfClientPersonalDetailsViewModel {
    return ResultOfClientPersonalDetailsViewModelFromJSONTyped(json, false);
}

export function ResultOfClientPersonalDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfClientPersonalDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ClientPersonalDetailsViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfClientPersonalDetailsViewModelToJSON(value?: ResultOfClientPersonalDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': ClientPersonalDetailsViewModelToJSON(value.data),
        'Count': value.count,
    };
}

